import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt, FaYoutube } from 'react-icons/fa';
import { RiTwitterXFill } from 'react-icons/ri';
import PrivacyControls from './PrivacyControls';
import IubendaCookiePolicy from './IubendaCookiePolicy';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white pt-10 pb-5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About column */}
          <div>
            <h3 className="text-xl font-bold mb-4">Robin Hood Roma ODV</h3>
            <p className="mb-4 text-gray-300">
              Associazione di volontariato per pazienti e genitori di bambini 
              e adolescenti affetti da malattie ematologiche rare.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-400 transition-colors">
                <FaFacebook size={24} />
              </a>
              <a href="https://x.com/RobinHoodODV" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-400 transition-colors">
                <RiTwitterXFill size={24} />
              </a>
              <a href="https://www.instagram.com/robinhoodromaodv?igsh=MXR0c2lhNWVzYXRzag==" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-400 transition-colors">
                <FaInstagram size={24} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-400 transition-colors">
                <FaLinkedin size={24} />
              </a>
              <a href="https://www.youtube.com/@RobinHoodRomaOdv" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-400 transition-colors">
                <FaYoutube size={24} />
              </a>
            </div>
          </div>

          {/* Links column */}
          <div>
            <h3 className="text-xl font-bold mb-4">Link Utili</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-green-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/chi-siamo" className="text-gray-300 hover:text-green-400 transition-colors">Chi Siamo</Link>
              </li>
              <li>
                <Link to="/malattie-rare" className="text-gray-300 hover:text-green-400 transition-colors">Malattie Rare</Link>
              </li>
              <li>
                <Link to="/eventi" className="text-gray-300 hover:text-green-400 transition-colors">Eventi</Link>
              </li>
              <li>
                <Link to="/partners" className="text-gray-300 hover:text-green-400 transition-colors">Partners</Link>
              </li>
              <li>
                <Link to="/consiglio-direttivo" className="text-gray-300 hover:text-green-400 transition-colors">Attività</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info column */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contatti</h3>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <FaMapMarkerAlt className="mr-2" />
                <span>Via Benevento 6
00161 ROMA
Ematologia, 1° piano ambulatori e accettazione
malattie ematologiche rare
pediatriche</span>
              </li>
              <li className="flex items-center">
                <FaPhone className="mr-2" />
                <span>+39 3295585666</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-2" />
                <a href="mailto:robinhoodromaodv@gmail.com" className="hover:text-green-400 transition-colors">
                robinhoodromaodv@gmail.com
                </a>
              </li>
            </ul>
            <div className="mt-4">
              <Link to="/contatti" className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded text-white transition-colors">
                Scrivici
              </Link>
            </div>
          </div>

          {/* Support column */}
          <div>
            <h3 className="text-xl font-bold mb-4">Sostienici</h3>
            <p className="mb-4 text-gray-300">
              Il tuo contributo è fondamentale per continuare il nostro lavoro a favore di chi combatte contro le malattie ematologiche rare.
            </p>
            <div className="mt-4">
              <Link to="/sostienici" className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded text-white transition-colors">
                Dona Ora
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom footer */}
        <div className="mt-10 pt-6 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between">
            <div className="text-gray-400 mb-4 md:mb-0">
              &copy; {currentYear} Robin Hood Roma ODV. Tutti i diritti riservati.
            </div>
            <div className="flex flex-wrap gap-4 items-center text-gray-400">
              
              <span className="hover:text-green-400 transition-colors">
                <IubendaCookiePolicy />
              </span>
              <div className="ml-2 border-l border-gray-600 pl-4">
                <PrivacyControls />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

